import { render } from "./HeroiconsOutlineDatabase.vue?vue&type=template&id=11cba70d"
const script = {}

import exportComponent from "/home/tobias/Desktop/screenads/nova-custom2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineDatabase.vue"]])

export default __exports__